import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Box } from "@mui/material";
import "../../../assets/css/page/OnBoardingForm.scss";
import BaseButton from "../Common/Buttons/BaseButton";
import ConfirmationPopup from "../CommonComponents/PopUpCards/ConfirmationPopup";
import { ReactComponent as ConfirmationIcon } from "../../../assets/icons/Confirmation.svg";
import DynamicTable from "../CommonComponents/Table/DynamicTable";
import { gatewayQueueAction, getGatewayListAction } from "./Store/admin.action";

function GatewayStatus() {
  const dispatch = useDispatch();
  const [data, setData] = useState([{ sid: "" }]);
  const [modal, setModal] = useState(false);
  const [spin, setSpin] = useState(false);
  const [selectedGateway, setSelectedGateway] = useState("");
  const [selectedAction, setSelectedAction] = useState("");
  const init = async () => {
    const res: any = await dispatch(getGatewayListAction());
    setData(res?.table_data?.campaigns);
  };
  useEffect(() => {
    init();
  }, []);

  const refresh = async () => {
    await init();
  };
  const save = async () => {
    setSpin(true);
    await dispatch(gatewayQueueAction(selectedAction, selectedGateway));
    setSpin(false);
    setModal(false);
    init();
  };

  const actionFunc = async (action, gateway) => {
    setSelectedAction(action);
    setSelectedGateway(gateway);
    setModal(true);
  };
  
  return (
    <Box>
      <BaseButton variant="outlined" title="Refresh" handleClick={refresh} />
      <DynamicTable
        columns={[
          {
            label: "Gateway Name",
            field: "logical_name",
          },
          {
            label: "Gateway value",
            render: ({ gateway_name }) => gateway_name && gateway_name[0],
          },
          {
            label: "Active",
            field: "active",
          },
          {
            label: "Current Calls",
            field: "usage",
          },
          {
            label: "max_limit",
            field: "max_limit",
          },

          {
            label: "Answered",
            field: "on_call",
          },
          {
            label: "Streaming",
            field: "on_stream",
          },
          {
            label: "Queue",
            field: "queue_size",
          },

          {
            label: "Scheduled",
            field: "scheduled",
          },
          {
            label: "Action",
            render: ({ gateway_name }) => {
              const gateway = gateway_name && gateway_name[0];

              return (
                <Box className="d-flex w-30 ">
                  <button
                    className="btn btn-success m-1"
                    onClick={() => actionFunc("enable", gateway)}
                  >
                    Enable
                  </button>
                  <button
                    className="btn btn-success m-1"
                    onClick={() => actionFunc("clear", gateway)}
                  >
                    Clear Calls
                  </button>
                </Box>
              );
            },
          },
        ]}
        data={data}
        rowCount={data?.length}
        style={{ marginTop: 1 }}
      />

      <ConfirmationPopup
        handleSave={save}
        heading={"Action"}
        message={`Are you sure you want to ${selectedAction} the gateway - ${selectedGateway}`}
        show={modal}
        toggle={() => {
          setSelectedAction("");
          setSelectedGateway("");
          setModal(false);
        }}
        spin={spin}
        Icon={ConfirmationIcon}
      />
    </Box>
  );
}
export default GatewayStatus;
